module.exports = __webpack_public_path__ + "static/media/Angela Yee.7e3b513c.png";